export const config = {
  // Linear / Non Linear mode
  linearMode: false,

  // Display an introduction page at start
  introductionPage: true,

  // Score needed to pass the test
  scoreToPass: 7,
}

export const AccountData = {
  user: {},
  progress: [],
  lastProgress: [],
  endtest: {},
  chapters: [
    //{ cId: 1, aId: 1, data: {}},
    //{ cId: 1, aId: 1, data: {}},
  ],
}

export const UserData = {
  id: 1,
  name: '',
  role: 'student',
}

export const ProgressItemData = {
  id: 1,
  progress: 0,
  total: 1,
  status: 'active',
}

export const EndtestData = {
  completed: false,
  passed: false,
  score: 0,
  answers: [],
}
